import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
import Automationtemplate from "../../component/course/automation-testing";

export default class Automationtestinginkolkata extends Component {
  render() {
    const title = "Automation Testing"
    const url ="automation-testing"
     const url1 ="-course-in-kolkata"
    const location = "kolkata" 
    const location1="Course in Kolkata"
    return(
      <>
        <NextSeoModule
          title={`${title} ${location1} - learnsoft.org`}
          description={`Elevate Your Skills with Top-notch Automation Testing Course in ${location}. Gain Practical Knowledge and Excel in Automated Testing Techniques. Enroll Now!`}
          url={`${location}/${url}${url1}`}
         img={`course/${url}.webp`}
          keyword={`${title} training in ${location}, ${title} certification in ${location}, Online ${title}  Training in ${location}, ${title} Online Training in ${location}, ${title} Syllabus, ${title} course in ${location}, ${title} classes in ${location}, ${title} institute in ${location}, Best ${title} training institute in ${location}, ${title} training and certification in ${location}, Best ${title} training in ${location}, ${title} coaching in ${location}, ${title} training center in ${location}, ${title} training provider in ${location}`}
        />
        <Layout navbarBackgroundColor="#281E1E">
        <Automationtemplate url1={"-course-in-kolkata"} title={title} url={url} relatedlocation={location} location={location} location1={location1} />
     </Layout>
      </>
    );
  }
}
